<template>
    <div class="container-wrapper">
        <div class="join-banner">
        </div>
        <div class="section back-white" id="blog">
            <div class="section padding-bottom" style="padding-top: 40px;">
                <div class="container">

                    <div class="six columns">
                        <div class="journal-wrap">
                            <img  src="./img/job4.jpg" alt="" data-scroll-reveal="enter right move 150px over 0.7s after 0.2s"/>
                            <div class="journal-det" data-scroll-reveal="enter right move 150px over 0.7s after 0.6s">
                                <h6>郑州</h6>
                                <h5>10k-15k</h5>
                                <a href="https://jobs.zhaopin.com/CZ280928280J00210523705.htm" target="_blank"><div class="link">查看详情</div></a>
                            </div>
                        </div>
                    </div>

                    <div class="six columns">
                        <div class="journal-wrap">
                            <img  src="./img/job2.jpg" alt="" data-scroll-reveal="enter right move 150px over 0.7s after 0.2s"/>
                            <div class="journal-det" data-scroll-reveal="enter right move 150px over 0.7s after 0.6s">
                                <h6>郑州</h6>
                                <h5>6k-8k</h5>
                                <a href="https://jobs.zhaopin.com/CC280928289J00473069905.htm" target="_blank"><div class="link">查看详情</div></a>
                            </div>
                        </div>
                    </div>
                    <div class="six columns">
                        <div class="journal-wrap-right">
                            <img  src="./img/job3.jpg" alt="" data-scroll-reveal="enter right move 150px over 0.7s after 0.2s"/>
                            <div class="journal-det-right" data-scroll-reveal="enter right move 150px over 0.7s after 0.6s">
                                <h6>郑州</h6>
                                <h5>4k-6k</h5>
                                <a href="https://jobs.zhaopin.com/CZ280928280J00405089605.htm" target="_blank"><div class="link">查看详情</div></a>
                            </div>
                        </div>
                    </div>
                    <div class="six columns">
                        <div class="journal-wrap-right">
                            <img  src="./img/job1.jpg" alt="" data-scroll-reveal="enter right move 150px over 0.7s after 0.2s"/>
                            <div class="journal-det-right" data-scroll-reveal="enter right move 150px over 0.7s after 0.6s">
                                <h6>郑州</h6>
                                <h5>4k-6k</h5>
                                <a href="https://jobs.zhaopin.com/CC280928289J00579795705.htm" target="_blank"><div class="link">查看详情</div></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "JoinUs"
    }
</script>

<style scoped>
    @import "css/skeleton.css";
    ul.slimmenu li a:hover,
    ul.slimmenu li a.mPS2id-highlight,
    .about-wrap .about-icon,
    .counter-wrap p,
    .des-programs-author.left p span,
    .des-programs-author.left .link,
    .des-programs-author.right p span,
    .des-programs-author.right .link,
    .services-wrap h5 span,
    .journal-det .link,
    .journal-det-right .link,
    .list-social-team li.icon-team a:hover,
    .project-page a:hover {
        color: #cfa144;
    }
    .back-white{
        background-color:#ffffff;
    }
    .join-banner {
        width: 100%;
        height: 421px;
        background: url("../join/img/joinus.jpg");
        background-size: 100% 100%;
    }
    .journal-wrap {
        position:relative;
        width:100%;
    }
    .journal-wrap:after {
        content: '';
        display: block;
        clear: both;
    }
    .section{
        position:relative;
        width:100%;
    }
    .journal-wrap-right {
        position:relative;
        width:100%;
    }
    .journal-wrap-right:after {
        content: '';
        display: block;
        clear: both;
    }
    .journal-wrap-right img {
        display:block;
        float:right;
    }
    .journal-det {
        position:absolute;
        width:45%;
        top:50px;
        right:0;
        z-index:3;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding:30px;
        display:block;
        background:rgba(255,255,255,.95);
    }
    .journal-det h6{
        position:relative;
        text-align:left;
        font-family: 'Poppins', sans-serif;
        font-weight:500;
        font-size: 11px;
        line-height: 16px;
        letter-spacing:1px;
        color:#000;
        padding-bottom:3px;
    }
    .journal-det h6 span{
        position:relative;
        padding-left:60px;
    }
    .journal-det h6 span:before {
        content:'';
        position:absolute;
        width:20px;
        height:1px;
        top:8px;
        left:16px;
        background-color:#646464;
    }
    .journal-det h5{
        position:relative;
        text-align:left;
        padding-bottom:20px;
    }
    .journal-det .link{
        position:relative;
        overflow:hidden;
        display:block;
        font-weight:300;
        font-family: 'Poppins', sans-serif;
        font-size:12px;
        line-height:18px;
        letter-spacing:2px;
        text-align:left;
        float:left;
        -webkit-transition: all 300ms linear;
        -moz-transition: all 300ms linear;
        -o-transition: all 300ms linear;
        -ms-transition: all 300ms linear;
        transition: all 300ms linear;
    }
    .journal-det .link:hover{
        color:#b2b2b2;
    }
    .journal-det .link:before {
        content:'';
        position:absolute;
        width:100%;
        height:2px;
        bottom:0;
        left:-100%;
        -webkit-transition: all 200ms linear;
        -moz-transition: all 200ms linear;
        -o-transition: all 200ms linear;
        -ms-transition: all 200ms linear;
        transition: all 200ms linear;
    }
    .journal-det .link:hover:before {
        left:-2px;
    }


    .journal-wrap-right {
        position:relative;
        width:100%;
    }
    .journal-wrap-right:after {
        content: '';
        display: block;
        clear: both;
    }
    .journal-wrap-right img {
        width:70%;
        display:block;
        float:right;
    }
    .journal-det-right {
        position:absolute;
        width:45%;
        top:50px;
        left:0;
        z-index:3;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding:30px;
        display:block;
        background:rgba(255,255,255,.95);
    }
    .journal-det-right h6{
        position:relative;
        text-align:right;
        font-family: 'Poppins', sans-serif;
        font-weight:500;
        font-size: 11px;
        line-height: 16px;
        letter-spacing:1px;
        color:#000;
        padding-bottom:3px;
    }
    .journal-det-right h6 span{
        position:relative;
        padding-left:60px;
    }
    .journal-det-right h6 span:before {
        content:'';
        position:absolute;
        width:20px;
        height:1px;
        top:8px;
        left:16px;
        background-color:#646464;
    }
    .journal-det-right h5{
        position:relative;
        text-align:right;
        padding-bottom:20px;
    }
    .journal-det-right .link{
        position:relative;
        overflow:hidden;
        display:block;
        font-weight:300;
        font-family: 'Poppins', sans-serif;
        font-size:12px;
        line-height:18px;
        letter-spacing:2px;
        text-align:right;
        float:right;
        -webkit-transition: all 300ms linear;
        -moz-transition: all 300ms linear;
        -o-transition: all 300ms linear;
        -ms-transition: all 300ms linear;
        transition: all 300ms linear;
    }
    .journal-det-right .link:hover{
        color:#b2b2b2;
    }
    .journal-det-right .link:before {
        content:'';
        position:absolute;
        width:100%;
        height:2px;
        bottom:0;
        left:-100%;
        -webkit-transition: all 200ms linear;
        -moz-transition: all 200ms linear;
        -o-transition: all 200ms linear;
        -ms-transition: all 200ms linear;
        transition: all 200ms linear;
    }
    .journal-det-right .link:hover:before {
        left:-2px;
    }
    @media only screen and (min-width: 1200px) {
        .journal-det{
            border-right:3px solid #cfa144;
            box-shadow: 0px 0 15px -4px rgba(21, 21, 21, 0.2);
        }
        .journal-det-right{
            border-left:3px solid #cfa144;
            box-shadow: 0px 0 15px -4px rgba(21, 21, 21, 0.2);
        }
    }
    @media only screen and (min-width: 1200px) {
        .translate-left{
            border-right:3px solid #cfa144;
            box-shadow: 0px 0 15px -4px rgba(21, 21, 21, 0.2);
        }
        .translate-right{
            border-left:3px solid #cfa144;
            box-shadow: 0px 0 15px -4px rgba(21, 21, 21, 0.2);
        }
    }

</style>